/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";
import PartsFooterGroupMain from "../../../blocks/parts/footer-group-main.tsx";
import PartsFooterGroupSub from "../../../blocks/parts/footer-group-sub.tsx";
import PartsFooterLogo from "../../../blocks/parts/footer-logo.tsx";
import PartsHeaderButton from "../../../blocks/parts/header-button.tsx";
import PartsHeaderDateLockup from "../../../blocks/parts/header-date-lockup.tsx";
import PartsMegamenuColumn from "../../../blocks/parts/megamenu-column.tsx";
import PartsMegamenuCta from "../../../blocks/parts/megamenu-cta.tsx";
import PartsMegamenuPage from "../../../blocks/parts/megamenu-page.tsx";
import PartsPartSiteHeader from "../../../blocks/parts/part-site-header.tsx";

const manifest = {
  "acf/blog-blog-post-header": dynamic(() =>
    import("../../../blocks/blog/blog-post-header.tsx"), "blocks/blog/blog-post-header.tsx"),
  "acf/content-accordion": dynamic(() =>
    import("../../../blocks/content/accordion.tsx"), "blocks/content/accordion.tsx"),
  "acf/content-blockquote": dynamic(() =>
    import("../../../blocks/content/blockquote.tsx"), "blocks/content/blockquote.tsx"),
  "acf/content-button": dynamic(() =>
    import("../../../blocks/content/button.tsx"), "blocks/content/button.tsx"),
  "acf/content-button-row": dynamic(() =>
    import("../../../blocks/content/button-row.tsx"), "blocks/content/button-row.tsx"),
  "acf/content-cta-button": dynamic(() =>
    import("../../../blocks/content/cta-button.tsx"), "blocks/content/cta-button.tsx"),
  "acf/content-cta-cards": dynamic(() =>
    import("../../../blocks/content/cta-cards.tsx"), "blocks/content/cta-cards.tsx"),
  "acf/content-cta-cards-item": dynamic(() =>
    import("../../../blocks/content/cta-cards-item.tsx"), "blocks/content/cta-cards-item.tsx"),
  "acf/content-featured-card": dynamic(() =>
    import("../../../blocks/content/featured-card.tsx"), "blocks/content/featured-card.tsx"),
  "acf/content-featured-card-button": dynamic(() =>
    import("../../../blocks/content/featured-card-button.tsx"), "blocks/content/featured-card-button.tsx"),
  "acf/content-file-download": dynamic(() =>
    import("../../../blocks/content/file-download.tsx"), "blocks/content/file-download.tsx"),
  "acf/content-film-list": dynamic(() =>
    import("../../../blocks/content/film-list.tsx"), "blocks/content/film-list.tsx"),
  "acf/content-gallery": dynamic(() =>
    import("../../../blocks/content/gallery.tsx"), "blocks/content/gallery.tsx"),
  "acf/content-hero-card": dynamic(() =>
    import("../../../blocks/content/hero-card.tsx"), "blocks/content/hero-card.tsx"),
  "acf/content-icon": dynamic(() =>
    import("../../../blocks/content/icon.tsx"), "blocks/content/icon.tsx"),
  "acf/content-icons-row": dynamic(() =>
    import("../../../blocks/content/icons-row.tsx"), "blocks/content/icons-row.tsx"),
  "acf/content-image": dynamic(() =>
    import("../../../blocks/content/image.tsx"), "blocks/content/image.tsx"),
  "acf/content-large-logo-grid": dynamic(() =>
    import("../../../blocks/content/large-logo-grid.tsx"), "blocks/content/large-logo-grid.tsx"),
  "acf/content-logo-item": dynamic(() =>
    import("../../../blocks/content/logo-item.tsx"), "blocks/content/logo-item.tsx"),
  "acf/content-logos": dynamic(() =>
    import("../../../blocks/content/logos.tsx"), "blocks/content/logos.tsx"),
  "acf/content-people-grid": dynamic(() =>
    import("../../../blocks/content/people-grid.tsx"), "blocks/content/people-grid.tsx"),
  "acf/content-people-grid-item": dynamic(() =>
    import("../../../blocks/content/people-grid-item.tsx"), "blocks/content/people-grid-item.tsx"),
  "acf/content-recently-viewed": dynamic(() =>
    import("../../../blocks/content/recently-viewed.tsx"), "blocks/content/recently-viewed.tsx"),
  "acf/content-spacer": dynamic(() =>
    import("../../../blocks/content/spacer.tsx"), "blocks/content/spacer.tsx"),
  "acf/content-table": dynamic(() =>
    import("../../../blocks/content/table.tsx"), "blocks/content/table.tsx"),
  "acf/content-table-row": dynamic(() =>
    import("../../../blocks/content/table-row.tsx"), "blocks/content/table-row.tsx"),
  "acf/content-top-films": dynamic(() =>
    import("../../../blocks/content/top-films.tsx"), "blocks/content/top-films.tsx"),
  "acf/content-video": dynamic(() =>
    import("../../../blocks/content/video.tsx"), "blocks/content/video.tsx"),
  "acf/film-film-contents": dynamic(() =>
    import("../../../blocks/film/film-contents.tsx"), "blocks/film/film-contents.tsx"),
  "acf/film-film-credits": dynamic(() =>
    import("../../../blocks/film/film-credits.tsx"), "blocks/film/film-credits.tsx"),
  "acf/film-film-guests": dynamic(() =>
    import("../../../blocks/film/film-guests.tsx"), "blocks/film/film-guests.tsx"),
  "acf/film-film-header": dynamic(() =>
    import("../../../blocks/film/film-header.tsx"), "blocks/film/film-header.tsx"),
  "acf/film-film-hierarchy": dynamic(() =>
    import("../../../blocks/film/film-hierarchy.tsx"), "blocks/film/film-hierarchy.tsx"),
  "acf/film-film-long-description": dynamic(() =>
    import("../../../blocks/film/film-long-description.tsx"), "blocks/film/film-long-description.tsx"),
  "acf/film-film-quotes": dynamic(() =>
    import("../../../blocks/film/film-quotes.tsx"), "blocks/film/film-quotes.tsx"),
  "acf/film-film-related": dynamic(() =>
    import("../../../blocks/film/film-related.tsx"), "blocks/film/film-related.tsx"),
  "acf/film-film-short-description": dynamic(() =>
    import("../../../blocks/film/film-short-description.tsx"), "blocks/film/film-short-description.tsx"),
  "acf/film-film-sidebar": dynamic(() =>
    import("../../../blocks/film/film-sidebar.tsx"), "blocks/film/film-sidebar.tsx"),
  "acf/film-film-sponsors": dynamic(() =>
    import("../../../blocks/film/film-sponsors.tsx"), "blocks/film/film-sponsors.tsx"),
  "acf/film-film-tickets": dynamic(() =>
    import("../../../blocks/film/film-tickets.tsx"), "blocks/film/film-tickets.tsx"),
  "acf/gallery-gallery-listing": dynamic(() =>
    import("../../../blocks/gallery/gallery-listing.tsx"), "blocks/gallery/gallery-listing.tsx"),
  "acf/guests-featured-guests": dynamic(() =>
    import("../../../blocks/guests/featured-guests.tsx"), "blocks/guests/featured-guests.tsx"),
  "acf/guests-guest-listing": dynamic(() =>
    import("../../../blocks/guests/guest-listing.tsx"), "blocks/guests/guest-listing.tsx"),
  "acf/hero-browse-quicklinks": dynamic(() =>
    import("../../../blocks/hero/browse-quicklinks.tsx"), "blocks/hero/browse-quicklinks.tsx"),
  "acf/hero-category-card-item": dynamic(() =>
    import("../../../blocks/hero/category-card-item.tsx"), "blocks/hero/category-card-item.tsx"),
  "acf/hero-category-card-row": dynamic(() =>
    import("../../../blocks/hero/category-card-row.tsx"), "blocks/hero/category-card-row.tsx"),
  "acf/hero-large-film-card": dynamic(() =>
    import("../../../blocks/hero/large-film-card.tsx"), "blocks/hero/large-film-card.tsx"),
  "acf/hero-large-strand-card": dynamic(() =>
    import("../../../blocks/hero/large-strand-card.tsx"), "blocks/hero/large-strand-card.tsx"),
  "acf/homepage-homepage-carousel": dynamic(() =>
    import("../../../blocks/homepage/homepage-carousel.tsx"), "blocks/homepage/homepage-carousel.tsx"),
  "acf/homepage-homepage-carousel-item": dynamic(() =>
    import("../../../blocks/homepage/homepage-carousel-item.tsx"), "blocks/homepage/homepage-carousel-item.tsx"),
  "acf/homepage-homepage-flexipasses": dynamic(() =>
    import("../../../blocks/homepage/homepage-flexipasses.tsx"), "blocks/homepage/homepage-flexipasses.tsx"),
  "acf/homepage-latest-news": dynamic(() =>
    import("../../../blocks/homepage/latest-news.tsx"), "blocks/homepage/latest-news.tsx"),
  "acf/media-releases-media-release-listing": dynamic(
    () => import("../../../blocks/media-releases/media-release-listing.tsx"),
    "blocks/media-releases/media-release-listing.tsx",
  ),
  "acf/merch-merch-tile": dynamic(() =>
    import("../../../blocks/merch/merch-tile.tsx"), "blocks/merch/merch-tile.tsx"),
  "acf/merch-merchandise-item": dynamic(() =>
    import("../../../blocks/merch/merchandise-item.tsx"), "blocks/merch/merchandise-item.tsx"),
  "acf/page-page-header": dynamic(() =>
    import("../../../blocks/page/page-header.tsx"), "blocks/page/page-header.tsx"),
  "acf/page-page-siderail": dynamic(() =>
    import("../../../blocks/page/page-siderail.tsx"), "blocks/page/page-siderail.tsx"),
  "acf/parts-acknowledgement-overlay": dynamic(() =>
    import("../../../blocks/parts/acknowledgement-overlay.tsx"), "blocks/parts/acknowledgement-overlay.tsx"),
  "acf/parts-footer-group-main": PartsFooterGroupMain,
  "acf/parts-footer-group-sub": PartsFooterGroupSub,
  "acf/parts-footer-logo": PartsFooterLogo,
  "acf/parts-header-alert": dynamic(() =>
    import("../../../blocks/parts/header-alert.tsx"), "blocks/parts/header-alert.tsx"),
  "acf/parts-header-button": PartsHeaderButton,
  "acf/parts-header-date-lockup": PartsHeaderDateLockup,
  "acf/parts-megamenu-column": PartsMegamenuColumn,
  "acf/parts-megamenu-cta": PartsMegamenuCta,
  "acf/parts-megamenu-page": PartsMegamenuPage,
  "acf/parts-part-error-page": dynamic(() =>
    import("../../../blocks/parts/part-error-page.tsx"), "blocks/parts/part-error-page.tsx"),
  "acf/parts-part-flexipasses": dynamic(() =>
    import("../../../blocks/parts/part-flexipasses.tsx"), "blocks/parts/part-flexipasses.tsx"),
  "acf/parts-part-site-footer": dynamic(() =>
    import("../../../blocks/parts/part-site-footer.tsx"), "blocks/parts/part-site-footer.tsx"),
  "acf/parts-part-site-header": PartsPartSiteHeader,
  "acf/search-search-cta-tile": dynamic(() =>
    import("../../../blocks/search/search-cta-tile.tsx"), "blocks/search/search-cta-tile.tsx"),
  "acf/search-search-group": dynamic(() =>
    import("../../../blocks/search/search-group.tsx"), "blocks/search/search-group.tsx"),
  "acf/search-search-patterns": dynamic(() =>
    import("../../../blocks/search/search-patterns.tsx"), "blocks/search/search-patterns.tsx"),
  "acf/search-suggested-search-group": dynamic(() =>
    import("../../../blocks/search/suggested-search-group.tsx"), "blocks/search/suggested-search-group.tsx"),
  "acf/strand-strand-header": dynamic(() =>
    import("../../../blocks/strand/strand-header.tsx"), "blocks/strand/strand-header.tsx"),
  "acf/templates-redirect-notice": dynamic(() =>
    import("../../../blocks/templates/redirect-notice.tsx"), "blocks/templates/redirect-notice.tsx"),
  "acf/tff-center-tff-center-program": dynamic(() =>
    import("../../../blocks/tff-center/tff-center-program.tsx"), "blocks/tff-center/tff-center-program.tsx"),
  "acf/tff-center-tff-center-sponsors": dynamic(() =>
    import("../../../blocks/tff-center/tff-center-sponsors.tsx"), "blocks/tff-center/tff-center-sponsors.tsx"),
  "acf/tff-center-tff-center-sponsors-item": dynamic(
    () => import("../../../blocks/tff-center/tff-center-sponsors-item.tsx"),
    "blocks/tff-center/tff-center-sponsors-item.tsx",
  ),
  "acf/tff-center-tff-center-tickets-header": dynamic(
    () => import("../../../blocks/tff-center/tff-center-tickets-header.tsx"),
    "blocks/tff-center/tff-center-tickets-header.tsx",
  ),
  "acf/tff-center-tff-full-schedule": dynamic(() =>
    import("../../../blocks/tff-center/tff-full-schedule.tsx"), "blocks/tff-center/tff-full-schedule.tsx"),
  "acf/tff-center-tff-next-stops": dynamic(() =>
    import("../../../blocks/tff-center/tff-next-stops.tsx"), "blocks/tff-center/tff-next-stops.tsx"),
  "acf/tickets-donate-campaign": dynamic(() =>
    import("../../../blocks/tickets/donate-campaign.tsx"), "blocks/tickets/donate-campaign.tsx"),
  "acf/tickets-donate-campaign-item": dynamic(() =>
    import("../../../blocks/tickets/donate-campaign-item.tsx"), "blocks/tickets/donate-campaign-item.tsx"),
  "acf/tickets-donate-campaign-page": dynamic(() =>
    import("../../../blocks/tickets/donate-campaign-page.tsx"), "blocks/tickets/donate-campaign-page.tsx"),
  "acf/tickets-donate-panel": dynamic(() =>
    import("../../../blocks/tickets/donate-panel.tsx"), "blocks/tickets/donate-panel.tsx"),
  "acf/tickets-flexipass-grid": dynamic(() =>
    import("../../../blocks/tickets/flexipass-grid.tsx"), "blocks/tickets/flexipass-grid.tsx"),
  "acf/tickets-flexipass-grid-custom": dynamic(() =>
    import("../../../blocks/tickets/flexipass-grid-custom.tsx"), "blocks/tickets/flexipass-grid-custom.tsx"),
  "acf/tickets-flexipass-tile": dynamic(() =>
    import("../../../blocks/tickets/flexipass-tile.tsx"), "blocks/tickets/flexipass-tile.tsx"),
  "acf/tickets-gift-card": dynamic(() =>
    import("../../../blocks/tickets/gift-card.tsx"), "blocks/tickets/gift-card.tsx"),
  "acf/tickets-merch-tile": dynamic(() =>
    import("../../../blocks/tickets/merch-tile.tsx"), "blocks/tickets/merch-tile.tsx"),
  "acf/venue-venue-header": dynamic(() =>
    import("../../../blocks/venue/venue-header.tsx"), "blocks/venue/venue-header.tsx"),
  "acf/venue-venue-listing": dynamic(() =>
    import("../../../blocks/venue/venue-listing.tsx"), "blocks/venue/venue-listing.tsx"),
  ...core,
};

const info = {
  "acf/blog-blog-post-header": { "slug": "blog/blog-post-header", "tags": [], "flags": { "fullWidth": true } },
  "acf/content-accordion": {
    "slug": "content/accordion",
    "tags": ["#subpage"],
    "flags": { "contentWidth": true, "marginRule": "long-card" },
  },
  "acf/content-blockquote": { "slug": "content/blockquote", "tags": ["#subpage"], "flags": { "contentWidth": true } },
  "acf/content-button": { "slug": "content/button", "tags": ["button"], "flags": {} },
  "acf/content-button-row": { "slug": "content/button-row", "tags": ["#subpage"], "flags": { "contentWidth": true } },
  "acf/content-cta-button": {
    "slug": "content/cta-button",
    "tags": ["#subpage"],
    "flags": { "contentWidth": true, "marginRule": "long-card" },
  },
  "acf/content-cta-cards": {
    "slug": "content/cta-cards",
    "tags": ["#homepage", "#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/content-cta-cards-item": { "slug": "content/cta-cards-item", "flags": {} },
  "acf/content-featured-card": {
    "slug": "content/featured-card",
    "tags": ["#homepage", "#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/content-featured-card-button": { "slug": "content/featured-card-button", "flags": {} },
  "acf/content-file-download": {
    "slug": "content/file-download",
    "tags": ["#subpage"],
    "flags": { "contentWidth": true, "marginRule": "long-card" },
  },
  "acf/content-film-list": {
    "slug": "content/film-list",
    "tags": ["#subpage", "#homepage", "#featured"],
    "flags": { "fullWidth": true },
  },
  "acf/content-gallery": { "slug": "content/gallery", "tags": ["#subpage"], "flags": { "fullWidth": true } },
  "acf/content-hero-card": {
    "slug": "content/hero-card",
    "tags": ["#subpage"],
    "flags": { "fullWidth": true, "marginRule": "large-card" },
  },
  "acf/content-icon": { "slug": "content/icon", "tags": ["#icon"], "flags": {} },
  "acf/content-icons-row": { "slug": "content/icons-row", "tags": ["#subpage"], "flags": { "contentWidth": true } },
  "acf/content-image": { "slug": "content/image", "tags": ["#subpage"], "flags": { "fullWidth": true } },
  "acf/content-large-logo-grid": {
    "slug": "content/large-logo-grid",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "long-card" },
  },
  "acf/content-logo-item": { "slug": "content/logo-item", "flags": {} },
  "acf/content-logos": { "slug": "content/logos", "tags": ["#subpage"], "flags": { "contentWidth": true } },
  "acf/content-people-grid": {
    "slug": "content/people-grid",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "long-card" },
  },
  "acf/content-people-grid-item": { "slug": "content/people-grid-item", "flags": {} },
  "acf/content-recently-viewed": {
    "slug": "content/recently-viewed",
    "tags": ["#subpage", "#homepage", "#featured"],
    "flags": { "fullWidth": true },
  },
  "acf/content-spacer": { "slug": "content/spacer", "tags": ["#subpage"], "flags": { "fullWidth": true } },
  "acf/content-table": {
    "slug": "content/table",
    "tags": ["#subpage", "#richtext"],
    "flags": { "contentWidth": true, "needsPadding": 1 },
  },
  "acf/content-table-row": { "slug": "content/table-row", "flags": { "contentWidth": true } },
  "acf/content-top-films": {
    "slug": "content/top-films",
    "tags": ["#subpage", "#homepage", "#featured"],
    "flags": { "fullWidth": true },
  },
  "acf/content-video": { "slug": "content/video", "tags": ["#subpage"], "flags": { "fullWidth": true } },
  "acf/film-film-contents": { "slug": "film/film-contents", "tags": ["film-text"], "flags": {} },
  "acf/film-film-credits": { "slug": "film/film-credits", "tags": ["film-sidebar"], "flags": {} },
  "acf/film-film-guests": { "slug": "film/film-guests", "tags": ["film-text"], "flags": {} },
  "acf/film-film-header": { "slug": "film/film-header", "tags": ["film-root"], "flags": {} },
  "acf/film-film-hierarchy": { "slug": "film/film-hierarchy", "tags": ["film-text"], "flags": {} },
  "acf/film-film-long-description": { "slug": "film/film-long-description", "tags": ["film-text"], "flags": {} },
  "acf/film-film-quotes": { "slug": "film/film-quotes", "tags": ["film-text"], "flags": {} },
  "acf/film-film-related": { "slug": "film/film-related", "tags": ["film-root"], "flags": {} },
  "acf/film-film-short-description": { "slug": "film/film-short-description", "tags": ["film-text"], "flags": {} },
  "acf/film-film-sidebar": { "slug": "film/film-sidebar", "flags": {} },
  "acf/film-film-sponsors": { "slug": "film/film-sponsors", "tags": ["film-sidebar"], "flags": {} },
  "acf/film-film-tickets": { "slug": "film/film-tickets", "tags": ["film-text"], "flags": {} },
  "acf/gallery-gallery-listing": {
    "slug": "gallery/gallery-listing",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true },
  },
  "acf/guests-featured-guests": {
    "slug": "guests/featured-guests",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "long-card" },
  },
  "acf/guests-guest-listing": {
    "slug": "guests/guest-listing",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true },
  },
  "acf/hero-browse-quicklinks": {
    "slug": "hero/browse-quicklinks",
    "tags": ["#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/hero-category-card-item": { "slug": "hero/category-card-item", "flags": {} },
  "acf/hero-category-card-row": {
    "slug": "hero/category-card-row",
    "tags": ["#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/hero-large-film-card": {
    "slug": "hero/large-film-card",
    "tags": ["#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/hero-large-strand-card": {
    "slug": "hero/large-strand-card",
    "tags": ["#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/homepage-homepage-carousel": {
    "slug": "homepage/homepage-carousel",
    "tags": ["#homepage"],
    "flags": { "fullWidth": true },
  },
  "acf/homepage-homepage-carousel-item": {
    "slug": "homepage/homepage-carousel-item",
    "tags": ["#homepage-carousel"],
    "flags": {},
  },
  "acf/homepage-homepage-flexipasses": {
    "slug": "homepage/homepage-flexipasses",
    "tags": ["#homepage", "#featured"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/homepage-latest-news": {
    "slug": "homepage/latest-news",
    "tags": ["#homepage", "#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/media-releases-media-release-listing": {
    "slug": "media-releases/media-release-listing",
    "tags": ["#subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/merch-merch-tile": {
    "slug": "merch/merch-tile",
    "tags": ["#subpage"],
    "flags": { "contentWidth": true, "marginRule": "large-card" },
  },
  "acf/merch-merchandise-item": { "slug": "merch/merchandise-item", "tags": [], "flags": {} },
  "acf/page-page-header": { "slug": "page/page-header", "tags": [], "flags": { "fullWidth": true } },
  "acf/page-page-siderail": {
    "slug": "page/page-siderail",
    "tags": ["#subpage-layout"],
    "flags": { "sideRail": true },
  },
  "acf/parts-acknowledgement-overlay": { "slug": "parts/acknowledgement-overlay", "flags": {} },
  "acf/parts-footer-group-main": { "slug": "parts/footer-group-main", "flags": {} },
  "acf/parts-footer-group-sub": { "slug": "parts/footer-group-sub", "flags": {} },
  "acf/parts-footer-logo": { "slug": "parts/footer-logo", "flags": {} },
  "acf/parts-header-alert": { "slug": "parts/header-alert", "flags": {} },
  "acf/parts-header-button": { "slug": "parts/header-button", "tags": ["#header-button"], "flags": {} },
  "acf/parts-header-date-lockup": { "slug": "parts/header-date-lockup", "flags": {} },
  "acf/parts-megamenu-column": { "slug": "parts/megamenu-column", "flags": {} },
  "acf/parts-megamenu-cta": { "slug": "parts/megamenu-cta", "flags": {} },
  "acf/parts-megamenu-page": { "slug": "parts/megamenu-page", "flags": {} },
  "acf/parts-part-error-page": { "slug": "parts/part-error-page", "flags": { "fullWidth": true } },
  "acf/parts-part-flexipasses": { "slug": "parts/part-flexipasses", "flags": {} },
  "acf/parts-part-site-footer": { "slug": "parts/part-site-footer", "flags": {} },
  "acf/parts-part-site-header": { "slug": "parts/part-site-header", "flags": {} },
  "acf/search-search-cta-tile": { "slug": "search/search-cta-tile", "flags": {} },
  "acf/search-search-group": { "slug": "search/search-group", "flags": {} },
  "acf/search-search-patterns": { "slug": "search/search-patterns", "flags": {} },
  "acf/search-suggested-search-group": { "slug": "search/suggested-search-group", "flags": {} },
  "acf/strand-strand-header": { "slug": "strand/strand-header", "tags": [], "flags": { "fullWidth": true } },
  "acf/templates-redirect-notice": { "slug": "templates/redirect-notice", "tags": [], "flags": {} },
  "acf/tff-center-tff-center-program": {
    "slug": "tff-center/tff-center-program",
    "tags": [],
    "flags": { "fullWidth": true },
  },
  "acf/tff-center-tff-center-sponsors": { "slug": "tff-center/tff-center-sponsors", "flags": {} },
  "acf/tff-center-tff-center-sponsors-item": { "slug": "tff-center/tff-center-sponsors-item", "flags": {} },
  "acf/tff-center-tff-center-tickets-header": {
    "slug": "tff-center/tff-center-tickets-header",
    "flags": { "fullWidth": true },
  },
  "acf/tff-center-tff-full-schedule": {
    "slug": "tff-center/tff-full-schedule",
    "tags": ["#homepage"],
    "flags": { "fullWidth": true },
  },
  "acf/tff-center-tff-next-stops": {
    "slug": "tff-center/tff-next-stops",
    "tags": ["#featured", "#homepage"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
  "acf/tickets-donate-campaign": {
    "slug": "tickets/donate-campaign",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "large-card" },
  },
  "acf/tickets-donate-campaign-item": { "slug": "tickets/donate-campaign-item", "flags": {} },
  "acf/tickets-donate-campaign-page": { "slug": "tickets/donate-campaign-page", "flags": {} },
  "acf/tickets-donate-panel": {
    "slug": "tickets/donate-panel",
    "tags": ["#subpage", "#homepage"],
    "flags": { "fullWidth": true, "marginRule": "large-card" },
  },
  "acf/tickets-flexipass-grid": {
    "slug": "tickets/flexipass-grid",
    "tags": ["#subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/tickets-flexipass-grid-custom": {
    "slug": "tickets/flexipass-grid-custom",
    "tags": ["#subpage"],
    "flags": { "fullWidth": true },
  },
  "acf/tickets-flexipass-tile": { "slug": "tickets/flexipass-tile", "tags": ["#pass"], "flags": {} },
  "acf/tickets-gift-card": {
    "slug": "tickets/gift-card",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "large-card" },
  },
  "acf/tickets-merch-tile": {
    "slug": "tickets/merch-tile",
    "tags": ["#subpage"],
    "flags": { "contentWidth": true, "marginRule": "large-card" },
  },
  "acf/venue-venue-header": { "slug": "venue/venue-header", "tags": [], "flags": { "fullWidth": true } },
  "acf/venue-venue-listing": {
    "slug": "venue/venue-listing",
    "tags": ["#subpage-layout"],
    "flags": { "fullWidth": true, "marginRule": "featured-card" },
  },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
